module.exports = __webpack_public_path__ + "img/pluto119.5d4e2da2.jpg";